import { useState, useEffect, useRef } from "react";
import {
  Autocomplete,
  CurrencyInput,
  Grid,
  TextField,
  FormControl,
  FormControlLabel,
  Button,
  Switch,
  Checkbox,
  InputAdornment,
  TextFielDecimalNumbers,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
} from "../../../components";
import { AddLayout } from "../../../layouts";
import {
  AtivoServicoService,
  ClassificacoesServicoNacionalService,
  CodigosServicosNacionalService,
  GrupoServicoService,
  notification,
  ServicoService,
  SessionService,
  GruposTributarioService,
} from "../../../services";
import { InputErros, PermisoesHelper, value } from "../../../helpers";
import {
  userLogs,
  responseErros,
  unformatPrice,
  voltar,
  timeoutBuscaAutocomplete,
} from "../../../utils";
import servicoValidator from "./middlewares/servico.validator";
import { Servico } from "./entities/servico.entity";
import { useImportContext } from "../../../contexts/import.context";
import { PrecificacaoServicoDialog } from "./dialog/precificacao-servico-dialog";
import { CopiarServicoDialog } from "./dialog/copiar-servico-dialog";
import ServicoPrecificacaoService from "../../../services/api/servico-precificacao.service";
import shortid from "shortid";

const servicoService = new ServicoService();
const grupoServicoService = new GrupoServicoService();
const codigosServicosNacionalService = new CodigosServicosNacionalService();
const classificacoesServicoNacionalService =
  new ClassificacoesServicoNacionalService();
const sessionService = new SessionService();
const servicoPrecificacaoService = new ServicoPrecificacaoService();
const ativoServicoService = new AtivoServicoService();
const gruposTributarioService = new GruposTributarioService();

let servicoEntity = new Servico({
  nome: null,
  descricao: null,
  grupoServicoId: null,
  estCodigoServicoNacionalId: null,
  estClassificacaoServicoNacionalId: null,
  aliquotaTotalSimplesNacional: 0,
  precoServico: null,
});

const AddServico = ({ match }) => {
  const inputRefCodigoServico = useRef();
  const inputRefClassificacaoServico = useRef();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("servicos-visualizar");
  const { id } = match.params;
  const [loading, setLoading] = useState(false);
  const { initialCollapses } = useImportContext();
  const [servico, setServico] = useState(servicoEntity);
  const [inputErro, setInputErro] = useState([]);
  const [userLog, setUserLog] = useState({});
  const [gruposTributarios, setGruposTributacao] = useState([]);
  const [grupoServico, setGrupoServico] = useState(null);
  const [ativosList, setAtivosList] = useState([]);
  const [codigoServicoNacional, setCodigoServicoNacional] = useState(null);
  const [classificacaoServicoNacional, setClassificacaoServicoNacional] =
    useState(null);
  const [openDialogPrecificacao, setOpenDialogPrecificacao] = useState(false);
  const [openCopiarServicoDialog, setOpenCopiarServicoDialog] = useState(false);
  const [grupoServicoList, setGrupoServicoList] = useState([]);
  const [codigosServicoNacionalList, setCodigosServicoNacionalList] = useState(
    [],
  );
  const [
    classificacoesServicoNacionalList,
    setClassificacoesServicoNacionalList,
  ] = useState([]);
  const [loadingAutoCompleteCodigo, setLoadingAutoCompleteCodigo] =
    useState(false);
  const [
    loadingAutoCompleteClassificacao,
    setLoadingAutoCompleteClassificacao,
  ] = useState(false);

  const configuracoes = sessionService.getConfiguracoes();
  const inputErros = new InputErros(inputErro, setInputErro);

  useEffect(() => {
    buscarDadosIniciais();
  }, []);

  function buscarDadosIniciais() {
    buscarGruposTributario();
    buscaServico();
    buscarAtivos();
  }

  const buscaServico = async () => {
    if (!id) {
      servicoEntity = new Servico({
        nome: null,
        descricao: null,
        grupoServicoId: null,
        estCodigoServicoNacionalId: null,
        estClassificacaoServicoNacionalId: null,
        aliquotaTotalSimplesNacional: 0,
        precoServico: null,
      });
      setServico({ ...servicoEntity });
      buscarGrupoServico();
      return;
    }
    setLoading(true);
    const result = await servicoService.getById(id);
    if (!result.isAxiosError) {
      servicoEntity = new Servico(result.data);

      setServico({ ...servicoEntity });
      buscarGrupoServico();
      if (result.data?.grupoServicoId) {
        await buscarGrupoServicoById(result.data?.grupoServicoId);
      }
      if (result.data?.estCodigoServicoNacionalId) {
        setCodigosServicoNacionalList([result.data.codigoServicoNacional]);
        setCodigoServicoNacional(result.data.codigoServicoNacional);
      }
      if (result.data?.estClassificacaoServicoNacionalId) {
        setClassificacoesServicoNacionalList([
          result.data.classificacaoServicoNacional,
        ]);
        setClassificacaoServicoNacional(
          result.data.classificacaoServicoNacional,
        );
      }
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarGruposTributario = () => {
    const filter = {
      attributes: ["id", "nome"],
      ativado: true,
      disabledInclude: true,
      nonPaginated: true,
    };
    gruposTributarioService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setGruposTributacao(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarGrupoServico = async (filtros) => {
    const filtrosTemp = {
      ...filtros,
      ativado: true,
      nonPaginated: true,
    };
    grupoServicoService.getAll(filtrosTemp).then((result) => {
      if (!result.isAxiosError) {
        setGrupoServicoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarGrupoServicoById = async (grupoServicoId) => {
    const result = await grupoServicoService.getById(grupoServicoId);
    if (!result.isAxiosError) {
      setGrupoServico(result.data);
    } else {
      responseErros(result);
    }
  };

  const buscarAtivos = async () => {
    const result = await ativoServicoService.getAll();
    if (!result.isAxiosError) {
      const listaDeAtivos = result.data.filter((ativo) => !!ativo?.ativado);
      setAtivosList(listaDeAtivos);
    } else {
      responseErros(result);
    }
  };

  const handleOpenCopiarServicoDialog = () => {
    setOpenCopiarServicoDialog(true);
  };

  const copiarServico = async (servicoId) => {
    if (!servicoId) return;
    setLoading(true);
    const result = await servicoService.getById(servicoId);
    if (!result.isAxiosError) {
      const servicoOrigem = result.data;
      servicoEntity = new Servico({
        ...servicoOrigem,
        codigo: null,
        ativado: true,
        precificacoes: (servicoOrigem.precificacoes ?? []).map((item) => ({
          id: shortid.generate(),
          tipo: item.tipo,
          itemId: item.itemId ?? null,
          descricao: item.descricao ?? "",
          qtdHoras: item.qtdHoras,
          vlPeca: item.vlPeca,
        })),
      });
      servicoEntity.estCodigoServicoNacionalId =
        servicoOrigem.estCodigoServicoNacionalId ?? null;
      servicoEntity.estClassificacaoServicoNacionalId =
        servicoOrigem.estClassificacaoServicoNacionalId ?? null;
      if (servicoOrigem.grupoServicoId) {
        await buscarGrupoServicoById(servicoOrigem.grupoServicoId);
      }
      if (servicoOrigem.estCodigoServicoNacionalId) {
        setCodigosServicoNacionalList([servicoOrigem.codigoServicoNacional]);
        setCodigoServicoNacional(servicoOrigem.codigoServicoNacional);
      }
      if (servicoOrigem.estClassificacaoServicoNacionalId) {
        setClassificacoesServicoNacionalList([
          servicoOrigem.classificacaoServicoNacional,
        ]);
        setClassificacaoServicoNacional(
          servicoOrigem.classificacaoServicoNacional,
        );
      }
      setServico({ ...servicoEntity });
      notification.sucessoGenericos("Serviço copiado com sucesso");
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const salvarPrecificacoesServico = async (novoServicoId) => {
    const precificacoes = servicoEntity?.precificacoes ?? [];
    if (!precificacoes.length) return;
    if (!novoServicoId) {
      notification.alertaGenericos(
        "Serviço cadastrado, mas a precificação não pôde ser salva. Edite o serviço e refaça a precificação.",
      );
      return;
    }
    const body = {
      idServico: novoServicoId,
      precificacoes: precificacoes.map((item) => ({
        estServicoId: novoServicoId,
        itemId: item.itemId ?? null,
        tipo: item.tipo,
        qtdHoras: parseFloat(item.qtdHoras) || 0,
        vlPeca: parseFloat(item.vlPeca) || 0,
        descricao: item.descricao || "",
      })),
      servico: {
        id: novoServicoId,
        custoOperacionalIndireto:
          parseFloat(servicoEntity.custoOperacionalIndireto) || 0,
        comissao: parseFloat(servicoEntity.comissao) || 0,
        issIbsCbs: parseFloat(servicoEntity.issIbsCbs) || 0,
        taxaCartao: parseFloat(servicoEntity.taxaCartao) || 0,
        taxaAdm: parseFloat(servicoEntity.taxaAdm) || 0,
        lucro: parseFloat(servicoEntity.lucro) || 0,
        precoServico: servicoEntity.precoServico,
      },
    };
    const res = await servicoPrecificacaoService.upsert(body);
    if (res.isAxiosError) responseErros(res);
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(servico);
    setUserLog(logs);
  }

  const handleInputChange = (event) => {
    event.persist();
    servicoEntity.setHandleChangeInput(event.target.name, event.target.value);
    setServico({ ...servicoEntity });
  };

  const handleChangeCheckbox = (event) => {
    event.persist();
    const name = event.target.name;
    const value = servicoEntity[name];
    if (value) {
      servicoEntity.setHandleChangeInput("prazoRecorrencia", null);
    }
    servicoEntity.setHandleChangeInput(name, !value);
    setServico({ ...servicoEntity });
  };

  const handleNumberChange = (event) => {
    event.persist();
    const { name, value } = event.target;
    const parsedValue = parseInt(value);
    servicoEntity.setHandleChangeInput(name, parsedValue);
    setServico({ ...servicoEntity });
  };

  const handleAliquotaTotalSimplesNacional = (event) => {
    servicoEntity.setHandleChangeInput(
      event.target.name,
      unformatPrice(event.target.value),
    );
    setServico({ ...servicoEntity });
  };

  const handleInputBlur = (event) => {
    event.persist();
    servicoEntity.setHandleChangeInput(
      event.target.name,
      unformatPrice(event.target.value),
    );
    setServico({ ...servicoEntity });
  };

  const handleChangeSwitch = (e) => {
    servicoEntity.setHandleChangeSwitch(e.target.name, e.target.checked);
    setServico({ ...servicoEntity });
  };

  const handleChangeAutocomplete = (name, value) => {
    servicoEntity.setHandleChangeAutoComplete(name, value);
    if (name === "grupoServicoId") {
      setGrupoServico(value);
    }
    setServico((prevState) => ({ ...prevState, ...servicoEntity }));
  };

  const handleChangeSelect = (event) => {
    const { name, value } = event.target;
    servicoEntity.setHandleChangeInput(name, value);
    setServico({ ...servicoEntity });
  };

  const handleSubmit = async (indiceSelecionado) => {
    setLoading(true);
    servicoEntity.converterUnidadesTempo();
    if (configuracoes.intervaloAgendamentos) {
      const intervalo = configuracoes.intervaloAgendamentos,
        tempoExecucao = servicoEntity.tempoExecucao;
      if (tempoExecucao % intervalo !== 0) {
        notification.alertaGenericos(
          "O tempo de execução entra em conflito com a agenda",
        );
        setInputErro("tempoExecucao");
        setLoading(false);
        return;
      }
    }
    servicoValidator
      .validate(servicoEntity, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await servicoService.atualizar(id, servicoEntity);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            initialCollapses();
            handleCancelar();
            voltar();
          } else {
            responseErros(response);
          }
        } else {
          const response = await servicoService.cadastrar(servicoEntity);
          if (!response.isAxiosError) {
            await salvarPrecificacoesServico(response.data?.id);
          }
          setLoading(false);
          if (!response.isAxiosError) {
            notification.cadastroSucesso();
            if (indiceSelecionado === 0) {
              initialCollapses();
              handleCancelar();
              voltar();
            } else {
              handleCancelar();
            }
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    servicoEntity = new Servico({
      nome: null,
      descricao: null,
      grupoServicoId: null,
      estCodigoServicoNacionalId: null,
      estClassificacaoServicoNacionalId: null,
      precoServico: null,
      aliquotaTotalSimplesNacional: 0,
    });
    setGrupoServico(null);
    setServico({ ...servicoEntity });
  };

  const onInputChangeCodigoServicoNacional = (event) => {
    if (
      event.key === "Enter" &&
      inputRefCodigoServico.current === document.activeElement
    ) {
      const eventValue = event.target?.value;
      if (eventValue?.length >= 2) {
        const filtros = {
          codigoNacional: eventValue,
          descricaoCompleta: eventValue,
        };
        setLoadingAutoCompleteCodigo(true);
        timeoutBuscaAutocomplete(buscarCodigosServicoNacional(filtros));
      }
    }
  };

  const onInputChangeClassificacaoServicoNacional = (event) => {
    if (
      event.key === "Enter" &&
      inputRefClassificacaoServico.current === document.activeElement
    ) {
      const eventValue = event.target?.value;
      if (eventValue?.length >= 2) {
        const filtros = {
          codigoClassificacao: eventValue,
          descricaoCompleta: eventValue,
        };
        timeoutBuscaAutocomplete(buscarClassificacoesServicoNacional(filtros));
      }
    }
  };

  function buscarCodigosServicoNacional(filtros) {
    const filtrosTemp = {
      ...filtros,
    };
    setLoadingAutoCompleteCodigo(true);
    codigosServicosNacionalService.getAll(filtrosTemp).then((result) => {
      setLoadingAutoCompleteCodigo(false);
      if (!result.isAxiosError) {
        setCodigosServicoNacionalList(result.data);
      } else {
        responseErros(result);
      }
    });
  }

  const buscarClassificacoesServicoNacional = async (filtros) => {
    const filtrosTemp = {
      ...filtros,
    };
    setLoadingAutoCompleteClassificacao(true);
    classificacoesServicoNacionalService.getAll(filtrosTemp).then((result) => {
      setLoadingAutoCompleteClassificacao(false);
      if (!result.isAxiosError) {
        setClassificacoesServicoNacionalList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  return (
    <AddLayout
      id={id}
      title={id ? "Editar Serviço" : "Cadastrar Serviço"}
      onClickSalvar={handleSubmit}
      loading={loading}
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      showUpdate={permissoesHelper.temPermisao("servicos-editar")}
      actions={
        <>
          {!id && (
            <Tooltip title="Copiar cadastro de serviço" placement="top">
              <IconButton
                color="padrao"
                className="mx-3"
                onClick={handleOpenCopiarServicoDialog}
              >
                <i className="ph-fill ph-copy" style={{ fontSize: 20 }}></i>
              </IconButton>
            </Tooltip>
          )}
          <FormControlLabel
            control={
              <Switch
                checked={servico?.ativado}
                onChange={handleChangeSwitch}
                name="ativado"
                color="primary"
              />
            }
            label={servico?.ativado ? "Ativado" : "Desativado"}
          />
        </>
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <TextField
            id="nome"
            name="nome"
            label="Nome"
            variant="outlined"
            margin="normal"
            value={servico?.nome || ""}
            onChange={(e) => {
              setInputErro([]);
              handleInputChange(e);
            }}
            fullWidth
            required
            error={inputErros.get("nome")}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
        <Grid item xs={7}>
          <TextField
            id="descricao"
            name="descricao"
            label="Descrição"
            variant="outlined"
            margin="normal"
            value={servico?.descricao || ""}
            onChange={(e) => {
              setInputErro([]);
              handleInputChange(e);
            }}
            fullWidth
            required
            error={inputErros.get("descricao")}
            inputProps={{ maxLength: 80 }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="tempoExecucao"
            name="tempoExecucao"
            label="Tempo de Execução"
            variant="outlined"
            margin="normal"
            value={servico?.tempoExecucao || ""}
            onChange={(e) => {
              setInputErro([]);
              handleNumberChange(e);
            }}
            fullWidth
            type="number"
            error={inputErros.get("tempoExecucao")}
            disableNumberArrows
            sx={{
              "& .MuiInputBase-root": {
                paddingRight: 0,
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Select
                    id="unidadeTempoExecucao"
                    name="unidadeTempoExecucao"
                    disableClearable
                    value={servico?.unidadeTempoExecucao || "MIN"}
                    onChange={handleChangeSelect}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "& .MuiSelect-select": { paddingRight: "24px" },
                    }}
                  >
                    <MenuItem value="MIN" sx={{ fontSize: 12 }}>
                      minutos
                    </MenuItem>
                    <MenuItem value="HORA" sx={{ fontSize: 12 }}>
                      horas
                    </MenuItem>
                  </Select>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <CurrencyInput
            id="precoServico"
            name="precoServico"
            label="Preço do Serviço"
            variant="outlined"
            margin="normal"
            fullWidth
            value={servico?.precoServico || ""}
            onBlur={handleInputBlur}
            error={inputErros.get("precoServico")}
          />
        </Grid>
        <Grid item xs={3}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              required
              id="grupoServicoId"
              name="grupoServicoId"
              options={grupoServicoList}
              loadingText="Carregando"
              autoHighlight
              getOptionLabel={(option) =>
                option.descricao ? `${option.descricao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Grupo de Serviço"
                  variant="outlined"
                  required
                  error={inputErros.get("grupoServicoId")}
                />
              )}
              onChange={(_, newValue) => {
                handleChangeAutocomplete("grupoServicoId", newValue);
              }}
              value={grupoServico}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <Autocomplete
            id="grupoTributarioId"
            name="grupoTributarioId"
            options={gruposTributarios}
            noOptionsText="Sem opções"
            getOptionLabel={(option) => option.nome ?? ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Grupo Tributário"
                margin="normal"
                variant="outlined"
                error={inputErros.get("grupoTributarioId")}
              />
            )}
            onChange={(_, value) =>
              handleChangeAutocomplete("grupoTributarioId", value)
            }
            value={value.autoComplete(
              gruposTributarios,
              servico.grupoTributarioId,
            )}
          />
        </Grid>
        <Grid item xs={2}>
          <TextFielDecimalNumbers
            id="aliquotaTotalSimplesNacional"
            name="aliquotaTotalSimplesNacional"
            label="Alíquota Simples Nacional (%)"
            margin="normal"
            onBlur={handleAliquotaTotalSimplesNacional}
            value={servico?.aliquotaTotalSimplesNacional ?? ""}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="codigoServicoMunicipal"
            name="codigoServicoMunicipal"
            label="Código Serviço Municipal"
            variant="outlined"
            margin="normal"
            value={servico?.codigoServicoMunicipal || ""}
            onChange={(e) => {
              setInputErro([]);
              handleInputChange(e);
            }}
            fullWidth
            error={inputErros.get("codigoServicoMunicipal")}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="estCodigoServicoNacionalId"
              name="estCodigoServicoNacionalId"
              options={codigosServicoNacionalList}
              autoHighlight
              getOptionLabel={(option) =>
                option?.codigoNacional
                  ? `${option.codigoNacional} - ${
                      option.descricaoCompleta || ""
                    }`
                  : ""
              }
              getOptionSelected={(option, value) => option?.id === value?.id}
              noOptionsText="Sem opções"
              loading={loadingAutoCompleteCodigo}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Código Serviço Nacional"
                  variant="outlined"
                  inputRef={inputRefCodigoServico}
                  onKeyDown={(e) => onInputChangeCodigoServicoNacional(e)}
                  error={inputErros.get("estCodigoServicoNacionalId")}
                />
              )}
              onChange={(_, newValue) => {
                handleChangeAutocomplete(
                  "estCodigoServicoNacionalId",
                  newValue,
                );
                setCodigoServicoNacional(newValue);
              }}
              value={codigoServicoNacional}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="estClassificacaoServicoNacionalId"
              name="estClassificacaoServicoNacionalId"
              options={classificacoesServicoNacionalList}
              autoHighlight
              loading={loadingAutoCompleteClassificacao}
              getOptionLabel={(option) =>
                option?.codigoClassificacao
                  ? `${option.codigoClassificacao} - ${
                      option.descricaoCompleta || ""
                    }`
                  : ""
              }
              getOptionSelected={(option, value) => option?.id === value?.id}
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Classificação Serviço Nacional"
                  variant="outlined"
                  inputRef={inputRefClassificacaoServico}
                  onKeyDown={(e) =>
                    onInputChangeClassificacaoServicoNacional(e)
                  }
                  error={inputErros.get("estClassificacaoServicoNacionalId")}
                />
              )}
              onChange={(_, newValue) => {
                handleChangeAutocomplete(
                  "estClassificacaoServicoNacionalId",
                  newValue,
                );
                setClassificacaoServicoNacional(newValue);
              }}
              value={classificacaoServicoNacional}
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        {ativosList.length > 0 && (
          <Grid item xs={2}>
            <FormControlLabel
              className="mt-3"
              label="Serviço Recorrente"
              control={
                <Checkbox
                  color="primary"
                  name="servicoRecorrente"
                  checked={servico?.servicoRecorrente ?? false}
                  onChange={handleChangeCheckbox}
                />
              }
            />
          </Grid>
        )}
        {servico?.servicoRecorrente && (
          <>
            <Grid item xs={2}>
              <TextField
                id="prazoRecorrencia"
                name="prazoRecorrencia"
                label="Prazo de Recorrência"
                variant="outlined"
                margin="normal"
                value={servico?.prazoRecorrencia || ""}
                onChange={(e) => {
                  setInputErro([]);
                  handleNumberChange(e);
                }}
                fullWidth
                required
                type="number"
                error={inputErros.get("prazoRecorrencia")}
                disableNumberArrows
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">dias</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="tempoAntecedencia"
                name="tempoAntecedencia"
                label="Tempo de Antecedência"
                variant="outlined"
                margin="normal"
                value={servico?.tempoAntecedencia || ""}
                onChange={(e) => {
                  setInputErro([]);
                  handleNumberChange(e);
                }}
                fullWidth
                required
                type="number"
                error={inputErros.get("tempoAntecedencia")}
                disableNumberArrows
                sx={{
                  "& .MuiInputBase-root": {
                    paddingRight: 0,
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Select
                        id="unidadeTempoAntecedencia"
                        name="unidadeTempoAntecedencia"
                        disableClearable
                        value={servico?.unidadeTempoAntecedencia || "HORA"}
                        onChange={handleChangeSelect}
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiSelect-select": { paddingRight: "24px" },
                        }}
                      >
                        <MenuItem value="HORA" sx={{ fontSize: 12 }}>
                          horas
                        </MenuItem>
                        <MenuItem value="DIA" sx={{ fontSize: 12 }}>
                          dias
                        </MenuItem>
                      </Select>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </>
        )}
        <Grid item xs={12} className="d-flex justify-content-end">
          <Button
            variant="contained"
            color="primary"
            disableElevation
            className="fw-bold rounded-3"
            onClick={() => setOpenDialogPrecificacao(true)}
          >
            Precificar Serviço
          </Button>
        </Grid>
      </Grid>
      <PrecificacaoServicoDialog
        open={openDialogPrecificacao}
        setOpen={setOpenDialogPrecificacao}
        idServico={id}
        servicoEntity={servicoEntity}
        setServico={setServico}
      />
      <CopiarServicoDialog
        open={openCopiarServicoDialog}
        setOpen={setOpenCopiarServicoDialog}
        handleCopiarServico={copiarServico}
      />
    </AddLayout>
  );
};

export default AddServico;
